import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';

import React from 'react';
import { Row, Col, Radio, Input, Divider, Button, message } from 'antd';
import { } from '@ant-design/icons';
import { isNotEmpty, isEmpty } from '../Service/Utils';


class NewGroupMeansureView extends React.Component {
    constructor() {
        super();
        this.state = {
            category: 'TRADE'
        };
    }

    render() {
        return <>
            <Row>
                <Col>
                    <h2>新增指标</h2>
                </Col>
            </Row>
            <Divider />
            <Row justify="center" style={{ margin: '0 0 16px 0' }}>
                <Col flex="100px" style={{ alignSelf: 'center', textAlign: 'right' }}>
                    <span>指标名称：</span>
                </Col>
                <Col flex="400px">
                    <Input
                        value={this.state.name}
                        onChange={({ target: { value } }) => {
                            this.setState({ name: value, nameError: undefined });
                        }}
                        placeholder="给指标起个名字"
                    />
                    {isNotEmpty(this.state.nameError) && <div>
                        <span style={{ color: 'red' }}>{this.state.nameError}</span>
                    </div>}
                </Col>
            </Row>


            <Row justify="center" style={{ margin: '0 0 16px 0' }}>
                <Col flex="100px" style={{ alignSelf: 'center', textAlign: 'right' }}>
                    <span>指标类型：</span>
                </Col>
                <Col flex="400px">
                    <Radio.Group
                        value={this.state.category}
                        onChange={({ target: { value } }) => this.setState({ category: value })}
                    >
                        <Radio value="TRADE">交易核心指标</Radio>
                        <Radio value="USER">用户核心指标</Radio>
                        <Radio value="REFERRAL">导流核心指标</Radio>
                    </Radio.Group>
                </Col>
            </Row>

            <Row justify="center" style={{ margin: '0 0 16px 0' }}>
                <Col flex="100px" style={{ textAlign: 'right' }}>
                    <span>指标定义描述：</span>
                </Col>
                <Col flex="400px">
                    <Input.TextArea
                        value={this.state.desc}
                        onChange={({ target: { value } }) => this.setState({ desc: value, descError: undefined })}
                        style={{ width: '100%' }}
                        rows={4}
                    />
                    {isNotEmpty(this.state.descError) && <div>
                        <span style={{ color: 'red' }}>{this.state.descError}</span>
                    </div>}
                </Col>
            </Row>

            <Row justify="center" style={{ margin: '0 0 16px 0' }}>
                <Col flex="100px" style={{ textAlign: 'right' }}>
                    <span>指标文字口径：</span>
                </Col>
                <Col flex="400px">
                    <Input.TextArea
                        value={this.state.spec}
                        onChange={({ target: { value } }) => this.setState({ spec: value })}
                        style={{ width: '100%' }}
                        rows={4}
                    />
                </Col>
            </Row>

            <Row justify="center" style={{ margin: '0 0 16px 0' }}>
                <Col flex="100px" style={{ textAlign: 'right' }}>
                    <span>指标SQL口径：</span>
                </Col>
                <Col flex="400px">
                    <div id="side-spec-by-sql-editor" style={{ textAlign: 'left', border: '1px solid #d9d9d9' }}></div>
                </Col>
            </Row>

            <Row justify="center">
                <Col flex="100px">
                    <Button type="primary" onClick={this.newMeasure.bind(this)}>提交</Button>
                </Col>
                <Col flex="100px">
                    <Button href="/data_map/group_measure_desc">取消</Button>
                </Col>
            </Row>
        </>;
    }

    componentDidMount() {
        const domNode = document.getElementById('side-spec-by-sql-editor');
        const instance = monaco.editor.create(domNode, {
            value: '',
            theme: 'vs-light',
            fontSize: 12,
            language: 'sql',
            automaticLayout: true
        });
        this.editor = instance;
        this.editor.layout({
            height: 300
        });

        auth.appendLog(`数据地图-新建集团核心指标`);
    }

    async newMeasure() {
        let err = 0;
        if (isEmpty(this.state.name)) {
            this.setState({ nameError: '名称不能为空' });
            err++;
        } else {
            this.setState({ nameError: undefined });
        }

        if (isEmpty(this.state.desc)) {
            this.setState({ descError: '指标定义描述不能为空' });
            err++;
        } else {
            this.setState({ descError: undefined });
        }

        if (err > 0) {
            message.error('配置错误!无法新建指标。');
            return;
        }

        const measure = { ...this.state, specBySql: this.editor.getValue() };
        await UIFetchService.post(`/api/v1/measure/group/measures`, measure);
        message.success('保存成功');
        window.location = "/data_map/group_measure_desc";
    }
};


// const meansuresConf = {
//     TRADE: {
//         title: '交易核心指标',
//         icon: <TradeIcon />
//     },
//     USER: {
//         title: '用户核心指标',
//         icon: <UserIcon />
//     },
//     REFERRAL: {
//         title: '导流核心指标',
//         icon: <ReferralIcon />
//     },
// };

export default NewGroupMeansureView;